import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';

import { PayloadOrderOutput, Subscription } from '../../models';
import { SubscriptionApiService } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsService {
  get subscriptionsList$(): Observable<Subscription[]> {
    return this.#subscriptionsList$.asObservable();
  }
  readonly #subscriptionsList$ = new BehaviorSubject<Subscription[]>([]);

  constructor(private api: SubscriptionApiService) {}

  getSubscriptions(): Observable<Subscription[]> {
    return this.api.list().pipe(tap((subscriptions) => this.#subscriptionsList$.next(subscriptions)));
  }

  create(payload: Partial<PayloadOrderOutput>): Observable<Subscription[]> {
    return this.api.create(payload).pipe(switchMap(() => this.getSubscriptions()));
  }

  toggle(id: string, enabled: boolean): Observable<Subscription[]> {
    return this.api.toggle(id, enabled).pipe(switchMap(() => this.getSubscriptions()));
  }

  update(id: string, payload: Partial<PayloadOrderOutput>): Observable<Subscription[]> {
    return this.api.update(id, payload).pipe(switchMap(() => this.getSubscriptions()));
  }

  delete(id: string): Observable<Subscription[]> {
    return this.api.delete(id).pipe(switchMap(() => this.getSubscriptions()));
  }
}
